// Tamil translations (தமிழ்)
import { TranslationKeys } from "./en";

export const ta: TranslationKeys = {
  // App name
  appName: "தேவி இம்பெக்ஸ்",
  managementSystem: "மேலாண்மை அமைப்பு",

  // Common
  loading: "ஏற்றுகிறது...",
  save: "சேமி",
  saveChanges: "மாற்றங்களை சேமி",
  cancel: "ரத்து",
  delete: "நீக்கு",
  deleting: "நீக்குகிறது...",
  edit: "திருத்து",
  create: "உருவாக்கு",
  add: "சேர்",
  addDetail: "விவரம் சேர்",
  update: "புதுப்பி",
  search: "தேடு",
  filter: "வடிகட்டு",
  clear: "அழி",
  clearFilters: "வடிகட்டிகளை அழி",
  confirm: "உறுதிப்படுத்து",
  back: "பின்",
  next: "அடுத்து",
  previous: "முந்தைய",
  yes: "ஆம்",
  no: "இல்லை",
  actions: "செயல்கள்",
  action: "செயல்",
  status: "நிலை",
  date: "தேதி",
  total: "மொத்தம்",
  grandTotal: "மொத்த தொகை",
  details: "விவரங்கள்",
  noData: "தரவு இல்லை",
  error: "பிழை",
  success: "வெற்றி",
  warning: "எச்சரிக்கை",
  info: "தகவல்",
  print: "அச்சிடு",
  optional: "விருப்பத்திற்கு",
  required: "தேவை",
  selectCompany: "நிறுவனம் தேர்வு செய்",
  selectProgram: "புரோகிராம் தேர்வு செய்",
  selectProgramFirst: "முதலில் புரோகிராம் தேர்வு செய்",
  typeToSearch: "தேட தட்டச்சு செய்",
  noDetailsAdded:
    'விவரங்கள் எதுவும் சேர்க்கப்படவில்லை. தொடங்க "விவரம் சேர்" கிளிக் செய்யவும்.',
  calculatedTotalRolls: "கணக்கிடப்பட்ட மொத்த ரோல்கள்",
  calculatedTotalWeight: "கணக்கிடப்பட்ட மொத்த எடை",
  basicInformation: "அடிப்படை தகவல்",
  noteId: "குறிப்பு ID",
  created: "உருவாக்கப்பட்டது",
  phone: "தொலைபேசி",
  representative: "பிரதிநிதி",
  representativeName: "பிரதிநிதி பெயர்",
  representativePhone: "பிரதிநிதி தொலைபேசி",
  selectDia: "டையா தேர்வு செய்",
  selectGauge: "கேஜ் தேர்வு செய்",
  selectType: "வகை தேர்வு செய்",
  notFound: "கிடைக்கவில்லை",

  // Navigation / Sidebar
  nav: {
    home: "முகப்பு",
    companies: "நிறுவனங்கள்",
    employees: "ஊழியர்கள்",
    machines: "இயந்திரங்கள்",
    receivedNotes: "பெற்ற குறிப்புகள்",
    programs: "புரோகிராம்கள்",
    deliveries: "டெலிவரிகள்",
    invoices: "இன்வாய்ஸ்கள்",
    inventory: "சரக்கு",
    employeeShifts: "ஊழியர் ஷிப்ட்கள்",
    metrics: "அளவீடுகள்",
    productionMetrics: "உற்பத்தி அளவீடுகள்",
    employeeMetrics: "ஊழியர் அளவீடுகள்",
    viewAnalytics: "பார்வை பகுப்பாய்வு",
    finance: "நிதி",
    users: "பயனர்கள்",
    auditLog: "தணிக்கை பதிவு",
    settings: "அமைப்புகள்",
    logout: "வெளியேறு",
    changePassword: "கடவுச்சொல் மாற்று",
  },

  // Change Password
  changePassword: {
    title: "கடவுச்சொல் மாற்று",
    currentPassword: "தற்போதைய கடவுச்சொல்",
    newPassword: "புதிய கடவுச்சொல்",
    confirmPassword: "புதிய கடவுச்சொல் உறுதிப்படுத்து",
    changeButton: "கடவுச்சொல் மாற்று",
    changing: "மாற்றுகிறது...",
    success: "கடவுச்சொல் வெற்றிகரமாக மாற்றப்பட்டது",
    currentPasswordIncorrect: "தற்போதைய கடவுச்சொல் தவறானது",
    passwordMismatch: "புதிய கடவுச்சொற்கள் பொருந்தவில்லை",
    passwordTooShort: "கடவுச்சொல் குறைந்தது 6 எழுத்துகள் இருக்க வேண்டும்",
    error: "கடவுச்சொல் மாற்ற முடியவில்லை",
  },

  // Login page
  login: {
    title: "உள்நுழை",
    email: "மின்னஞ்சல்",
    password: "கடவுச்சொல்",
    loginButton: "உள்நுழை",
    loggingIn: "உள்நுழைகிறது...",
    invalidCredentials: "தவறான மின்னஞ்சல் அல்லது கடவுச்சொல்",
    loginFailed: "உள்நுழைவு தோல்வியடைந்தது",
    forgotPassword: "கடவுச்சொல் மறந்துவிட்டதா?",
  },

  // Forgot Password
  forgotPassword: {
    title: "கடவுச்சொல் மறந்துவிட்டது",
    subtitle: "உங்கள் மின்னஞ்சலை உள்ளிடுங்கள், மீட்டமைப்பு இணைப்பை அனுப்புவோம்",
    emailPlaceholder: "உங்கள் மின்னஞ்சல் முகவரியை உள்ளிடுக",
    sendResetLink: "மீட்டமைப்பு இணைப்பை அனுப்பு",
    sending: "அனுப்புகிறது...",
    successTitle: "உங்கள் மின்னஞ்சலை சரிபாருங்கள்",
    successMessage: "உங்கள் மின்னஞ்சல் முகவரிக்கு கடவுச்சொல் மீட்டமைப்பு வழிமுறைகளை அனுப்பியுள்ளோம்.",
    backToLogin: "உள்நுழைவுக்கு திரும்பு",
    tryAgain: "மீண்டும் முயற்சிக்கவும்",
    errorMessage: "மீட்டமைப்பு இணைப்பை அனுப்ப முடியவில்லை. மீண்டும் முயற்சிக்கவும்.",
  },

  // Reset Password
  resetPassword: {
    title: "கடவுச்சொல் மீட்டமை",
    subtitle: "உங்கள் புதிய கடவுச்சொல்லை உள்ளிடுக",
    newPassword: "புதிய கடவுச்சொல்",
    confirmPassword: "கடவுச்சொல் உறுதிப்படுத்து",
    resetButton: "கடவுச்சொல் மீட்டமை",
    resetting: "மீட்டமைக்கிறது...",
    successTitle: "கடவுச்சொல் மீட்டமைப்பு வெற்றி",
    successMessage: "உங்கள் கடவுச்சொல் மீட்டமைக்கப்பட்டது. இப்போது உங்கள் புதிய கடவுச்சொல்லுடன் உள்நுழையலாம்.",
    errorMessage: "கடவுச்சொல்லை மீட்டமைக்க முடியவில்லை. இணைப்பு காலாவதியாகியிருக்கலாம்.",
    invalidToken: "தவறான அல்லது காலாவதியான மீட்டமைப்பு இணைப்பு",
    passwordMismatch: "கடவுச்சொற்கள் பொருந்தவில்லை",
    passwordTooShort: "கடவுச்சொல் குறைந்தது 6 எழுத்துகள் இருக்க வேண்டும்",
    goToLogin: "உள்நுழைவுக்கு செல்",
  },

  // Home / Dashboard
  home: {
    title: "இயந்திர நிலை டாஷ்போர்டு",
    inProgress: "நடந்து கொண்டிருக்கிறது",
    notYetStarted: "இன்னும் தொடங்கவில்லை",
    idle: "செயலற்றது",
    loadingMachineStatus: "இயந்திர நிலையை ஏற்றுகிறது...",
    noActivePrograms: "செயலில் உள்ள புரோகிராம்கள் இல்லை",
    noMachinesInCategory: "இந்த வகையில் {gauge} GG இயந்திரங்கள் இல்லை",
    machines14GG: "14 GG இயந்திரங்கள்",
    machines16GG: "16 GG இயந்திரங்கள்",
    weight: "எடை",
    rolls: "ரோல்கள்",
    remaining: "மீதம்",
    completed: "முடிந்தது",
    extra: "கூடுதல்",
    kgRemaining: "{value} கிலோ மீதம்",
    rollsRemaining: "{value} ரோல்கள் மீதம்",
  },

  // Companies
  companies: {
    title: "நிறுவனங்கள்",
    createNew: "நிறுவனம் சேர்",
    name: "நிறுவன பெயர்",
    phone: "தொலைபேசி",
    email: "மின்னஞ்சல்",
    address: "முகவரி",
    gst: "GST எண்",
    noCompanies: "நிறுவனங்கள் இல்லை",
    deleteConfirm: "இந்த நிறுவனத்தை நீக்க விரும்புகிறீர்களா?",
    details: "நிறுவன விவரங்கள்",
    edit: "நிறுவனம் திருத்து",
    searchByName: "நிறுவன பெயரால் தேடு",
    sortDefault: "சமீபத்திய புரோகிராம்கள் வரிசை",
    sortNameAsc: "பெயர் (அ-ஃ)",
    sortNameDesc: "பெயர் (ஃ-அ)",
  },

  // Employees
  employees: {
    title: "ஊழியர்கள்",
    createNew: "ஊழியர் சேர்",
    name: "பெயர்",
    phone: "தொலைபேசி",
    role: "பணி",
    noEmployees: "ஊழியர்கள் இல்லை",
    deleteConfirm: "இந்த ஊழியரை நீக்க விரும்புகிறீர்களா?",
    details: "ஊழியர் விவரங்கள்",
    edit: "ஊழியர் திருத்து",
    monthlySalary: "மாத சம்பளம்",
    payPerShift: "ஷிப்ட் ஊதியம்",
  },

  // Machines
  machines: {
    title: "இயந்திரங்கள்",
    createNew: "இயந்திரம் சேர்",
    dia: "டையா",
    gauge: "கேஜ்",
    machineType: "இயந்திர வகை",
    rib: "ரிப்",
    interlock: "இன்டர்லாக்",
    noMachines: "இயந்திரங்கள் இல்லை",
    deleteConfirm: "இந்த இயந்திரத்தை நீக்க விரும்புகிறீர்களா?",
    details: "இயந்திர விவரங்கள்",
    edit: "இயந்திரம் திருத்து",
  },

  // Received Notes
  receivedNotes: {
    title: "பெற்ற குறிப்புகள்",
    createNew: "குறிப்பு சேர்",
    createTitle: "பெற்ற குறிப்பு உருவாக்கு",
    editTitle: "பெற்ற குறிப்பு திருத்து",
    receiptNumber: "ரசீது எண்",
    company: "நிறுவனம்",
    yarnType: "நூல் வகை",
    lotNumber: "லாட் எண்",
    weight: "எடை",
    weightPerBag: "எடை/பை (கிலோ)",
    totalWeight: "மொத்த எடை",
    totalWeightKg: "மொத்த எடை (கிலோ)",
    bags: "பைகள்",
    numberOfBags: "பைகள் எண்ணிக்கை",
    counts: "கவுண்ட்ஸ்",
    mill: "மில்",
    color: "நிறம்",
    colors: "நிறங்கள்",
    receivedDate: "பெற்ற தேதி",
    noReceivedNotes: "பெற்ற குறிப்புகள் இல்லை",
    deleteConfirm: "இந்த குறிப்பை நீக்க விரும்புகிறீர்களா?",
    details: "குறிப்பு விவரங்கள்",
    edit: "குறிப்பு திருத்து",
    associatedPrograms: "இணைக்கப்பட்ட புரோகிராம்கள்",
    associatedDeliveries: "இணைக்கப்பட்ட டெலிவரிகள்",
    noPrograms: "புரோகிராம்கள் இணைக்கப்படவில்லை",
    noDeliveries: "டெலிவரிகள் இணைக்கப்படவில்லை",
    detailNumber: "விவரம் #",
    selectCompanyOrEnterNew:
      "தேட தட்டச்சு செய்யவும் அல்லது புதிய நிறுவன பெயரை உள்ளிடவும்",
  },

  // Programs
  programs: {
    title: "புரோகிராம்கள்",
    createNew: "புரோகிராம் சேர்",
    createTitle: "புரோகிராம் உருவாக்கு",
    editTitle: "புரோகிராம் திருத்து",
    programId: "புரோகிராம் ID",
    programNumber: "புரோகிராம் #",
    company: "நிறுவனம்",
    lot: "லாட்",
    lotOptional: "லாட் - விருப்பத்திற்கு",
    status: "நிலை",
    progress: "முன்னேற்றம்",
    totalWeight: "மொத்த எடை",
    completedWeight: "முடிந்த எடை",
    doneWeight: "செய்த எடை",
    remainingWeight: "மீதமுள்ள எடை",
    numberOfRolls: "ரோல்கள் எண்ணிக்கை",
    rollsOptional: "ரோல்கள் (விருப்பத்திற்கு)",
    dia: "டையா",
    gauge: "கேஜ்",
    gaugeGG: "கேஜ் (GG)",
    type: "வகை",
    weightKg: "எடை (கிலோ)",
    design: "டிசைன்",
    texture: "டெக்ஸ்சர்",
    textureOptional: "டெக்ஸ்சர் (விருப்பத்திற்கு)",
    noPrograms: "புரோகிராம்கள் இல்லை",
    deleteConfirm: "இந்த புரோகிராமை நீக்க விரும்புகிறீர்களா?",
    details: "புரோகிராம் விவரங்கள்",
    programDetails: "புரோகிராம் விவரங்கள்",
    edit: "புரோகிராம் திருத்து",
    share: "பகிர்",
    shareProgram: "புரோகிராம் பகிர்",
    shareViaSms: "SMS மூலம் பகிர்",
    copyLink: "லிங்க் நகலெடு",
    linkCopied: "லிங்க் நகலெடுக்கப்பட்டது",
    statusNotStarted: "தொடங்கவில்லை",
    statusPending: "நிலுவையில்",
    statusInProgress: "நடந்து கொண்டிருக்கிறது",
    statusCompleted: "முடிந்தது",
    statusDelivered: "டெலிவரி ஆனது",
    statusCancelled: "ரத்து செய்யப்பட்டது",
    associatedReceipts: "இணைக்கப்பட்ட ரசீதுகள் - விருப்பத்திற்கு",
    pleaseSelectCompanyFirst: "முதலில் நிறுவனம் தேர்வு செய்யவும்",
    noReceiptsForCompany: "தேர்ந்தெடுக்கப்பட்ட நிறுவனத்திற்கு ரசீதுகள் இல்லை",
    receipt: "ரசீது",
    typeToSearchCompany: "நிறுவனம் தேட தட்டச்சு செய்யவும்",
    productionHistory: "உற்பத்தி வரலாறு",
    employeeShiftDetails: "ஊழியர் ஷிப்ட் விவரங்கள்",
    noProductionData: "உற்பத்தி தரவு இல்லை",
    shiftDate: "ஷிப்ட் தேதி",
    shiftTime: "ஷிப்ட் நேரம்",
    employee: "ஊழியர்",
    noMachinesAvailable: "இயந்திரங்கள் இல்லை",
    noMachinesForSelection:
      "தேர்ந்தெடுக்கப்பட்ட கேஜ்/வகைக்கு இயந்திரங்கள் இல்லை",
    machineCombinationError: "இந்த டையா, கேஜ், வகை கலவை இயந்திரங்களில் இல்லை",
  },

  // Deliveries
  deliveries: {
    title: "டெலிவரிகள்",
    createNew: "டெலிவரி சேர்",
    createTitle: "டெலிவரி உருவாக்கு",
    editTitle: "டெலிவரி திருத்து",
    deliveryNumber: "டெலிவரி எண்",
    deliveryId: "டெலிவரி #",
    company: "நிறுவனம்",
    program: "புரோகிராம்",
    programLot: "புரோகிராம் லாட்",
    deliveryDate: "டெலிவரி தேதி",
    weight: "எடை",
    weightKg: "எடை (கிலோ)",
    rolls: "ரோல்கள்",
    noDeliveries: "டெலிவரிகள் இல்லை",
    deleteConfirm: "இந்த டெலிவரியை நீக்க விரும்புகிறீர்களா?",
    details: "டெலிவரி விவரங்கள்",
    deliveryDetails: "டெலிவரி விவரங்கள்",
    edit: "டெலிவரி திருத்து",
    deliveryPersonDetails: "டெலிவரி நபர் விவரங்கள்",
    deliveryPersonName: "டெலிவரி நபர் பெயர்",
    deliveryPersonPhone: "டெலிவரி நபர் தொலைபேசி",
    vehicleNumber: "வாகன எண்",
    machineType: "இயந்திர வகை",
    detailNumber: "விவரம் #",
  },

  // Invoices
  invoices: {
    title: "இன்வாய்ஸ்கள்",
    createNew: "இன்வாய்ஸ் சேர்",
    invoiceNumber: "இன்வாய்ஸ் எண்",
    company: "நிறுவனம்",
    invoiceDate: "இன்வாய்ஸ் தேதி",
    amount: "தொகை",
    noInvoices: "இன்வாய்ஸ்கள் இல்லை",
    deleteConfirm: "இந்த இன்வாய்ஸை நீக்க விரும்புகிறீர்களா?",
    details: "இன்வாய்ஸ் விவரங்கள்",
    edit: "இன்வாய்ஸ் திருத்து",
  },

  // Inventory
  inventory: {
    title: "சரக்கு",
    yarnType: "நூல் வகை",
    lotNumber: "லாட் எண்",
    weight: "எடை",
    available: "கிடைக்கும்",
    noInventory: "சரக்கு இல்லை",
  },

  // Employee Shifts
  employeeShifts: {
    title: "ஊழியர் ஷிப்ட்கள்",
    createNew: "ஷிப்ட் சேர்",
    employee: "ஊழியர்",
    machine: "இயந்திரம்",
    program: "புரோகிராம்",
    shiftDate: "ஷிப்ட் தேதி",
    shiftType: "ஷிப்ட் வகை",
    weight: "எடை",
    rolls: "ரோல்கள்",
    noShifts: "ஊழியர் ஷிப்ட்கள் இல்லை",
    deleteConfirm: "இந்த ஷிப்ட்டை நீக்க விரும்புகிறீர்களா?",
    details: "ஷிப்ட் விவரங்கள்",
    edit: "ஷிப்ட் திருத்து",
    day: "பகல்",
    night: "இரவு",
  },

  // Metrics
  metrics: {
    productionTitle: "உற்பத்தி அளவீடுகள்",
    employeeTitle: "ஊழியர் அளவீடுகள்",
    totalProduction: "மொத்த உற்பத்தி",
    averageDaily: "சராசரி தினசரி",
    topPerformers: "சிறந்த செயல்திறன்",
    dateRange: "தேதி வரம்பு",
    from: "இருந்து",
    to: "வரை",
    apply: "பயன்படுத்து",
  },

  // View Analytics
  viewAnalytics: {
    title: "பார்வை பகுப்பாய்வு",
    subtitle: "பகிரப்பட்ட புரோகிராம் லிங்க்கள் எத்தனை முறை பார்க்கப்படுகின்றன என்பதை கண்காணிக்கவும்",
    totalViews: "மொத்த பார்வைகள்",
    programsShared: "பகிரப்பட்ட புரோகிராம்கள்",
    companiesReached: "சென்றடைந்த நிறுவனங்கள்",
    lastViewed: "கடைசியாக பார்த்தது",
    program: "புரோகிராம்",
    company: "நிறுவனம்",
    views: "பார்வைகள்",
    noViews: "பகிரப்பட்ட புரோகிராம்கள் இன்னும் பார்க்கப்படவில்லை",
    mostViewed: "அதிகம் பார்க்கப்பட்ட புரோகிராம்கள்",
    recentlyViewed: "சமீபத்தில் பார்த்தவை",
    viewCount: "பார்வை எண்ணிக்கை",
    lastViewedAt: "கடைசியாக பார்த்த நேரம்",
    neverViewed: "ஒருபோதும் பார்க்கப்படவில்லை",
    shareToken: "பகிர்வு டோக்கன்",
    lot: "லாட்",
    status: "நிலை",
    loading: "பகுப்பாய்வு தரவை ஏற்றுகிறது...",
    error: "பகுப்பாய்வு தரவை ஏற்ற முடியவில்லை",
  },

  // Users
  users: {
    title: "பயனர்கள்",
    createNew: "பயனர் சேர்",
    inviteUser: "பயனரை அழை",
    inviteDescription: "பயனருக்கு அழைப்பு மின்னஞ்சல் அனுப்பவும். அவர்கள் கடவுச்சொல்லை அமைக்க இணைப்பு பெறுவார்கள்.",
    sendInvitation: "அழைப்பு அனுப்பு",
    inviting: "அனுப்புகிறது...",
    invitationSent: "அழைப்பு வெற்றிகரமாக அனுப்பப்பட்டது! பயனர் கடவுச்சொல்லை அமைக்க மின்னஞ்சல் பெறுவார்.",
    email: "மின்னஞ்சல்",
    role: "பணி",
    admin: "நிர்வாகி",
    user: "பயனர்",
    noUsers: "பயனர்கள் இல்லை",
    deleteConfirm: "இந்த பயனரை நீக்க விரும்புகிறீர்களா?",
    details: "பயனர் விவரங்கள்",
    edit: "பயனர் திருத்து",
    password: "கடவுச்சொல்",
    confirmPassword: "கடவுச்சொல் உறுதிப்படுத்து",
  },

  // Settings
  settings: {
    title: "அமைப்புகள்",
    organization: "நிறுவன அமைப்புகள்",
    smsSettings: "SMS அமைப்புகள்",
    generalSettings: "பொது அமைப்புகள்",
  },

  // Finance
  finance: {
    title: "நிதி",
    revenue: "வருவாய்",
    expenses: "செலவுகள்",
    profit: "லாபம்",
    invoiced: "பில் செய்தது",
    estimated: "மதிப்பீடு",
    salaries: "சம்பளங்கள்",
    revenueDetails: "வருவாய் விவரங்கள்",
    invoicedRevenue: "பில் செய்த வருவாய்",
    estimatedRevenue: "மதிப்பிட்ட வருவாய்",
    rate: "விலை",
    ratePerKg: "கிலோவுக்கு விலை (பில் செய்யாதவை)",
    delivery: "டெலிவரி",
    company: "நிறுவனம்",
    weight: "எடை",
    amount: "தொகை",
    noRevenueData: "இந்த மாதத்திற்கு வருவாய் தரவு இல்லை",
    enterExpenses: "செலவுகளை உள்ளிடுக",
    electricBill: "மின்சார பில்",
    needlesCost: "ஊசி செலவு",
    repairCost: "பழுது செலவு",
    employeeSalaries: "ஊழியர் சம்பளங்கள்",
    autoCalculated: "தானாக கணக்கிடப்பட்டது",
    shifts: "ஷிப்ட்கள்",
    payRate: "ஊதிய விகிதம்",
    salary: "சம்பளம்",
    shiftBased: "ஷிப்ட் அடிப்படை",
    additionalPayments: "கூடுதல் கொடுப்பனவுகள்",
    bonusOvertime: "போனஸ்/ஓவர்டைம்",
    noAdditionalPayments: "கூடுதல் கொடுப்பனவுகள் இல்லை",
    addPayment: "கொடுப்பனவு சேர்",
    paymentType: "கொடுப்பனவு வகை",
    noEmployees: "ஊழியர்கள் அமைக்கப்படவில்லை",
    addSalary: "சம்பளம் சேர்",
    employee: "ஊழியர்",
    type: "வகை",
    noSalaries: "சம்பளங்கள் எதுவும் சேர்க்கப்படவில்லை",
    saveExpenses: "செலவுகளை சேமி",
    saved: "செலவுகள் வெற்றிகரமாக சேமிக்கப்பட்டன",
    selectMonth: "விவரங்களைக் காண ஒரு மாதத்தைத் தேர்ந்தெடுக்கவும்",
    selectEmployee: "ஊழியர் தேர்வு செய்",
    salaryType: "சம்பள வகை",
    monthly: "மாதாந்திர",
    bonus: "போனஸ்",
    overtime: "ஓவர்டைம்",
    other: "மற்றவை",
    otherExpenses: "பிற செலவுகள்",
    noOtherExpenses: "பிற செலவுகள் எதுவும் சேர்க்கப்படவில்லை",
    description: "விளக்கம்",
    notes: "குறிப்புகள்",
  },

  // Language
  language: {
    select: "மொழி",
    english: "English",
    tamil: "தமிழ்",
  },

  // Validation messages
  validation: {
    required: "இந்த புலம் தேவை",
    invalidEmail: "தவறான மின்னஞ்சல் முகவரி",
    minLength: "குறைந்தது {min} எழுத்துகள் தேவை",
    maxLength: "அதிகபட்சம் {max} எழுத்துகள் அனுமதிக்கப்படும்",
    passwordMismatch: "கடவுச்சொற்கள் பொருந்தவில்லை",
  },

  // Date/Time
  dateTime: {
    today: "இன்று",
    yesterday: "நேற்று",
    thisWeek: "இந்த வாரம்",
    thisMonth: "இந்த மாதம்",
    lastMonth: "கடந்த மாதம்",
    custom: "தனிப்பயன்",
  },
};
